export { default } from './PaletteList';
